// @ts-ignore
import type {ICompanyState} from "@/store/states/ICompanyState.interface";

const company = {
    namespaced: true,
    state: <ICompanyState>{
        website_name: null,
        logo_url: null,
        logo_mobile_url: null,
        favicon: null,
        phone_number: null,
        contact_email: null,
        working_hours: null,
        facebook: null,
        twitter: null,
        instagram: null,
        linkedin: null,
        working_hours_footer: null,
        company_name: null,
        company_address: null,
        company_code: null,
        vat_code: null,
        info_mail: null,
        bank_account: null,
        finance_phone: null,
        director_phone: null,
        purchase_declaration: null,
        cookies_consent: null,
        privacy_policy: null,
        homepage_video: null,
        rent_service_without_driver_default_address: null,
        api_key: null,
    },
    mutations: {
        SET_WEBSITE_NAME(state, payload) {
            state.website_name = payload;
        },
        SET_LOGO_URL(state, payload) {
            state.logo_url = payload;
        },
        SET_LOGO_MOBILE_URL(state, payload) {
            state.logo_mobile_url = payload;
        },
        SET_FAVICON(state, payload) {
            state.favicon = payload;
        },
        SET_PHONE_NUMBER(state, payload) {
            state.phone_number = payload;
        },
        SET_CONTACT_EMAIL(state, payload) {
            state.contact_email = payload;
        },
        SET_WORKING_HOURS(state, payload) {
            state.working_hours = payload;
        },
        SET_FACEBOOK(state, payload) {
            state.facebook = payload;
        },
        SET_TWITTER(state, payload) {
            state.twitter = payload;
        },
        SET_INSTAGRAM(state, payload) {
            state.instagram = payload;
        },
        SET_LINKEDIN(state, payload) {
            state.linkedin = payload;
        },
        SET_WORKING_HOURS_FOOTER(state, payload) {
            state.working_hours_footer = payload;
        },
        SET_COMPANY_NAME(state, payload) {
            state.company_name = payload;
        },
        SET_COMPANY_ADDRESS(state, payload) {
            state.company_address = payload;
        },
        SET_COMPANY_CODE(state, payload) {
            state.company_code = payload;
        },
        SET_VAT_CODE(state, payload) {
            state.vat_code = payload;
        },
        SET_INFO_MAIL(state, payload) {
            state.info_mail = payload;
        },
        SET_BANK_ACCOUNT(state, payload) {
            state.bank_account = payload;
        },
        SET_FINANCE_PHONE(state, payload) {
            state.finance_phone = payload;
        },
        SET_DIRECTOR_PHONE(state, payload) {
            state.director_phone = payload;
        },
        SET_PURCHASE_DECLARATION(state, payload) {
            state.purchase_declaration = payload;
        },
        SET_COOKIES_CONSENT(state, payload) {
            state.cookies_consent = payload;
        },
        SET_PRIVACY_POLICY(state, payload) {
            state.privacy_policy = payload;
        },
        SET_HOMEPAGE_VIDEO(state, payload) {
            state.homepage_video = payload;
        },
        SET_RENT_SERVICE_WITHOUT_DRIVER_DEFAULT_ADDRESS(state, payload) {
            state.rent_service_without_driver_default_address = payload;
        },
    },
    actions: {
    },
    getters: {
    },
}

export default company;